import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Home from 'pages/home';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  conteiner:{
    direction: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  }

}));

const Index = () => {
  const classes = useStyles();

  return (
    <Home title={'Home'}>
      <Grid className={classes.conteiner} container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            
            Home

          </Paper>
        </Grid>
      </Grid>
    </Home>
  );
}

export default Index